// extracted by mini-css-extract-plugin
export default {"input":"C--z","button":"D--z","selected":"E--z","unavailable":"F--z","oos":"G--z","image":"H--z","paperCutDisabledOverlay":"I--z"};